import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appDateFormat]',
    standalone: false
})
export class DateFormatDirective {
    private isFormatting = false;

    constructor(private control: NgControl, private el: ElementRef<HTMLInputElement>) { }

    @HostListener('keypress', ['$event'])
    onKeyPress(event: KeyboardEvent) {
        const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '/'];
        if (!allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
    }

    @HostListener('input')
    onInput(): void {
        if (this.isFormatting) return;

        const input = this.el.nativeElement;
        const rawValue = input.value;

        // Déjà en format DD/MM/YYYY partiel valide — rien à reformater
        if (/^\d{0,2}(\/\d{0,2}(\/\d{0,4})?)?$/.test(rawValue)) return;

        const digits = rawValue.replace(/[^0-9]/g, '').slice(0, 8);
        const formatted = this.buildFormatted(digits);

        if (formatted === rawValue) return;

        const cursorPos = input.selectionStart ?? rawValue.length;
        const newCursorPos = this.computeCursorPos(rawValue, cursorPos);
        this.applyFormatted(input, formatted, newCursorPos);
    }

    @HostListener('paste', ['$event'])
    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const pastedData = event.clipboardData?.getData('text') || '';
        const digits = pastedData.replace(/[^0-9]/g, '').slice(0, 8);
        const formatted = this.buildFormatted(digits);
        this.applyFormatted(this.el.nativeElement, formatted, formatted.length);
    }

    private buildFormatted(digits: string): string {
        if (digits.length <= 2) return digits;
        if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
        return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4, 8)}`;
    }

    private computeCursorPos(rawValue: string, cursorPos: number): number {
        const digitsBeforeCursor = rawValue.slice(0, cursorPos).replace(/[^0-9]/g, '').length;
        let pos = digitsBeforeCursor;
        if (digitsBeforeCursor > 2) pos++;
        if (digitsBeforeCursor > 4) pos++;
        return pos;
    }

    private applyFormatted(input: HTMLInputElement, formatted: string, cursorPos: number): void {
        this.isFormatting = true;
        input.value = formatted;
        input.setSelectionRange(cursorPos, cursorPos);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        this.isFormatting = false;
    }

}
